import { Table } from '../../../components/general/table';
import { useTendersList } from './hook';
import { TendersListProps } from './props';

export const TendersList = ({ filters }: TendersListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useTendersList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
        />
    );
};
